import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZCreateAssetApiResponse = z.object({
  id: z.string().optional(),
  asset_id: z.string().optional(),
  name: z.string()
})

export interface CreateAssetPostRequest {
  type?: string
  name: string
  description: string
  site_id: string
  install_date: string
  modem_id?: string
  gateway_id?: string
  asset_type_id?: string
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZCreateAssetApiResponse,
  error: z.boolean()
})

export type CreateAssetApiResponse = z.infer<typeof ZCreateAssetApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function createAsset (
  createAssetPostRequest: CreateAssetPostRequest,
  onSuccess: (successResponse: CreateAssetApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/assets'

  interceptedAxios
    .post(url, createAssetPostRequest, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)

      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        // istanbul ignore next
        onFailure('Network Failure', error.status)
      }
    })
}
